import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServiceDetailsPage = lazy(() => import('../pages/service-details/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CarDetailsPage = lazy(() => import('../pages/car-details/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/service-details/:id',
    element: <ServiceDetailsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/car-details/:id',
    element: <CarDetailsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
